module.exports = __webpack_public_path__ + "static/media/13.1d5fe246.png";